"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Button = _interopRequireDefault(require("../../Button/Button"));

var _RemoveSortBtn = require("./RemoveSortBtn.styles");

var RemoveSortBtn = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      clearSorting = _ref.clearSorting,
      hidden = _ref.hidden,
      disabled = _ref.disabled;
  return (0, _jsxRuntime.jsx)("span", {
    css: [_RemoveSortBtn.styles.base, hidden && _RemoveSortBtn.styles.hidden, process.env.NODE_ENV === "production" ? "" : ";label:RemoveSortBtn;"],
    className: className,
    ref: ref,
    children: (0, _jsxRuntime.jsx)(_Button["default"], {
      type: "secondary",
      size: "small",
      onClick: clearSorting,
      disabled: disabled,
      children: "Remove sorting"
    })
  });
});
RemoveSortBtn.propTypes = {
  className: _propTypes.string,
  clearSorting: _propTypes.func,
  hidden: _propTypes.bool,
  disabled: _propTypes.bool
};
RemoveSortBtn.defaultProps = {
  className: undefined,
  clearSorting: function clearSorting() {},
  hidden: true,
  disabled: false
};
RemoveSortBtn.displayName = 'RemoveSortBtn';
var _default = RemoveSortBtn;
exports["default"] = _default;
//# sourceMappingURL=RemoveSortBtn.js.map